export default __webpack_public_path__ + "static/media/delivery.79e91617.png";